// Keepsy logo — official logo image from the public folder.
// Use <Logo /> for full mark+wordmark; <LogoMark /> for symbol only (cropped via CSS).

export function LogoMark({ size = 32, className = "" }) {
  return (
    <img
      src="/keepsy-logo.png"
      alt="Keepsy"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ objectPosition: "left center", objectFit: "contain" }}
    />
  );
}

export function Logo({ className = "", invert = false, height = 40 }) {
  // Invert turns the logo brighter on dark backgrounds (CSS filter).
  const filter = invert ? "brightness(0) invert(1)" : "none";
  return (
    <img
      src="/keepsy-logo.png"
      alt="Keepsy — Better Leads. More Clients."
      className={`block ${className}`}
      style={{ height: `${height}px`, width: "auto", filter }}
    />
  );
}

export default Logo;
